/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Try_Magic_Error_UnexpectedInputs */

const en_try_magic_error_unexpected = /** @type {(inputs: Try_Magic_Error_UnexpectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`An unexpected error occurred. Please try again.`)
};

const es_try_magic_error_unexpected = /** @type {(inputs: Try_Magic_Error_UnexpectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ocurrió un error inesperado. Por favor inténtalo de nuevo.`)
};

/**
* | output |
* | --- |
* | "An unexpected error occurred. Please try again." |
*
* @param {Try_Magic_Error_UnexpectedInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const try_magic_error_unexpected = /** @type {((inputs?: Try_Magic_Error_UnexpectedInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Try_Magic_Error_UnexpectedInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_try_magic_error_unexpected(inputs)
	return en_try_magic_error_unexpected(inputs)
});